import { useEffect } from "react";
import { userStore } from "../entities/User/store/userStore.js";
import { withProviders } from "./providers";
import "./index.css";
import { ROLES } from "shared/config";
import router from "pages";
import { RouterProvider } from "react-router-dom";

function App() {

  /**
   * Any logic or components placed in App wont be included in authentication and authorization
   * which is provided by RouterProvider. Use App only for global logic and components, most
   * likely you will find a better place for your stuff :P.
   */

  // TODO Refactor roles spaghetti

  const user = userStore((state) => state.user);
  const setIsUserTester = userStore((state) => state.setIsUserTester);
  const setIsUserCorporateCard = userStore(
    (state) => state.setIsUserCorporateCard
  );
  const setIsUserLocalAdmin = userStore((state) => state.setIsUserLocalAdmin);
  const setIsUserAP = userStore((state) => state.setIsUserAP);
  const setIsUserSupervisor = userStore((state) => state.setIsUserSupervisor);
  const setIsUserAdditionalAcceptor = userStore(
    (state) => state.setIsUserAdditionalAcceptor
  );
  const setIsUseAdministration = userStore(
    (state) => state.setIsUseAdministration
  );
  const setIsUserNA = userStore((state) => state.setIsUserNA);
  const setIsUserCostGroup = userStore((state) => state.setIsUserCostGroup);
  const setIsUserLocalHR = userStore((state) => state.setIsUserLocalHR);
  const setIsUserPL = userStore((state) => state.setIsUserPL);

  useEffect(() => {
    if (!Object.keys(user).length) return;
    const isTester = user.roles.data.some((role) => role.name === "Tester");
    const isLocalAdmin = user.roles.data.some(
      (role) => role.name === ROLES.LOCAL_ADMINISTRATOR
    );
    const isUserAccountsPayable = user.roles.data.some(
      (role) => role.name === ROLES.ACCOUNTS_PAYABLE
    );
    const isUserSupervisor = user.roles.data.some(
      (role) => role.name === ROLES.SUPERVISOR
    );
    const isUserCorporateCard =
      Object.keys(user?.card_types ?? {})?.length >= 1;

    const isUserAdditionalAcceptor = user.roles.data.some(
      (role) => role.name === ROLES.ADDITIONAL_ACCEPTOR
    );
    const isUserAdministration = user.roles.data.some(
      (role) => role.name === ROLES.ADMINISTRATION
    );
    const isUserFromNorthAmerica =
      user?.country_code === "US" || user?.country_code === "CA";
    const isUserCostGroup = user.roles.data.some(
      (role) => role.name === ROLES.COST_GROUP
    );

    const isUserLocalHR = user.roles.data.some(
      (role) => role.name === ROLES.LOCAL_HR
    );
    const isUserPL = user?.country_code === "PL";

    setIsUserTester(isTester);
    setIsUserLocalAdmin(isLocalAdmin);
    setIsUserCorporateCard(isUserCorporateCard);
    setIsUserAP(isUserAccountsPayable);
    setIsUserSupervisor(isUserSupervisor);
    setIsUserAdditionalAcceptor(isUserAdditionalAcceptor);
    setIsUseAdministration(isUserAdministration);
    setIsUserNA(isUserFromNorthAmerica);
    setIsUserPL(isUserPL);
    setIsUserLocalHR(isUserLocalHR);
    setIsUserCostGroup(isUserCostGroup);
    // eslint-disable-next-line
  }, [user]);

  return <RouterProvider router={router} />;
}

export default withProviders(App);
